import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OwnerMgmtCmsService } from '../owner-management.service';
import { OwnerMgmtCms } from '../owner-management';
import { DevelopmentService } from '@app/_components/development';

@Component({
    selector: 'app-owner-management',
    templateUrl: './owner-management.component.html',
    styleUrls: ['./owner-management.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OwnerMgmtCmsComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private ownerMgmtCmsService: OwnerMgmtCmsService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private developmentService: DevelopmentService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.ownerMgmtCms = data.ownerMgmtCms,
			this.statuses = ownerMgmtCmsService.statuses;
	}

	@Input() ownerMgmtCms: OwnerMgmtCms;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	ownerMgmtCmsId: number;
	developmentList: any[]=[];

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'ownerMgmtCmsId': [],
		'name': [],
		'teaserDesc': [],
		'featuresDesc': [],
		'ownerBenefitDesc': [],
		'revenueBenefitDesc': [],
		'mainBenefitDesc': [],
		'hskpBenefitDesc': [],
		'mgmtRate': [],
		'questionAnswerId': [],
		'developmentId': [],
	};
	
	ngOnInit() {
		this.primengConfig.ripple = true;
		this.fetchDevelopment();
		this.formBuild();

		// if we were passed the whole ownerMgmtCms object
		if (this.ownerMgmtCms) {
			this.ownerMgmtCmsId = this.ownerMgmtCms.ownerMgmtCmsId;
			this.fixDates();
			this.form1.patchValue(this.ownerMgmtCms);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.ownerMgmtCmsId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.ownerMgmtCmsService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ownerMgmtCms = res.data.ownerMgmtCms;
						this.doAdd.emit(this.ownerMgmtCms);
					},
					(err: any) => {
						console.log('ownerMgmtCms-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('ownerMgmtCms: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.ownerMgmtCmsService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ownerMgmtCms = res.data.ownerMgmtCms;
						this.doUpdate.emit(this.ownerMgmtCms);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.ownerMgmtCmsService.delete(this.ownerMgmtCms.ownerMgmtCmsId)
				.subscribe(
					(res: any) => {
						console.log('ownerMgmtCms-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.ownerMgmtCms);
					},
					(err: any) => {
						console.log('ownerMgmtCms-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			ownerMgmtCmsId: [this.ownerMgmtCmsId],
			name: [],
			teaserDesc: [],
			featuresDesc: [],
			ownerBenefitDesc: [],
			revenueBenefitDesc: [],
			mainBenefitDesc: [],
			hskpBenefitDesc: [],
			mgmtRate: [],
			questionAnswerId: [],
			developmentId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.ownerMgmtCms.ownerMgmtCmsDate = moment(this.ownerMgmtCms.ownerMgmtCmsDate).toDate();
	}
	
	fetchDevelopment() 
	{
			try {
				this.developmentService.findAll()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.developmentList = res.data.developments;
							return this.developmentList;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}
}
